module.exports = "<div class=\"gw-quote-cell-header\">\r\n    {{'quoteandbind.ho.directives.HoOfferingSelection.defaultBaseCoverages.General Coverages'| translate}}\r\n</div>\r\n<gw-qnb-multiple-offering-view-internal coverage-table=\"$ctrl.baseCoverageArray\" id=\"default_base\"></gw-qnb-multiple-offering-view-internal>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/ho/directives/HoOfferingSelection/defaultQuoteView/defaultBaseCoverages/defaultBaseCoverages.html
// module id = 1056
// module chunks = 0